// vue-router rejects the promise of a navigation that a later navigation supersedes, and
// nothing in pentakill catches it, so every one reaches Sentry as an unhandled rejection
// and prints a red stack in the user's console. This removes the cause; the ignoreErrors
// entries in sentryFilters.js cover the symptom for any path this misses.

// Installed at module scope so it is in effect for every call site regardless of when
// anything else initialises. A genuine error is rethrown: this must not become a blanket
// router-level error sink.
export function installNavigationFailureCatch(Router) {
  ;['push', 'replace'].forEach((method) => {
    const original = Router.prototype[method]

    Router.prototype[method] = function (location, onComplete, onAbort) {
      // vue-router 3.6.5 returns a Promise only when neither callback is supplied
      // (vue-router.common.js:3032-3056); calling .catch on the callback form would throw.
      if (onComplete || onAbort) return original.call(this, location, onComplete, onAbort)

      return original.call(this, location).catch((error) => {
        // Resolve undefined rather than the failure object. A successful push resolves with
        // the route, so returning the Error here would make `await router.push(x)` hand a
        // caller something whose .name reads 'NavigationDuplicated' instead of the route name.
        if (Router.isNavigationFailure(error)) return undefined
        throw error
      })
    }
  })
}
